import { defineMessage } from 'react-intl';

/** Shared i18n for focus-track headers (visibility toggles). */
export const focusTrackMessages = {
  hide: defineMessage({
    id: 'logger.streamScreen.focusTracks.hide',
    defaultMessage: 'Ocultar pista',
  }),
  show: defineMessage({
    id: 'logger.streamScreen.focusTracks.show',
    defaultMessage: 'Mostrar pista',
  }),
};
